import React, {Component} from 'react'

import Card from '../components/Card'
import Pager from '../components/Pager'

export default class VoteList extends Component {

  static defaultProps = {
    pagerVisible: true,
    pagerHash: null,
    pageParamName: 'page',
    className: 'pal-cards',
    limit: 30,
    showMore: null
  }

  render() {

    const {votes, page, count, showMore, pageParamName, pagerVisible, pagerHash, limit, uncover, voteBack, gameType} = this.props

    return <div className={this.props.className}>
      {votes.slice(0, limit).map((vote, index) =>
        <Card index={index} key={vote.hiddenId} valentine={vote} uncover={uncover} voteBack={voteBack} gameType={gameType} />)}
      <div className="clearfix"></div>
      {showMore != null && count >= limit ? <p><a href={showMore.url} className='underline'>{showMore.title}</a></p> : null }
      {pagerVisible ? <Pager count={parseInt(count)} current={parseInt(page)} paramName={pageParamName} hash={pagerHash} /> : null}
    </div>
  }
}
